module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_L-2537.be9090db.png";